import request from '@/utils/request'

const BASE = '/coffee/billing'

export function getBillingPending () {
  return request({
    url: `${BASE}/pending`,
    method: 'get'
  })
}

export function getBillingConfirmCase (params) {
  return request({
    url: `${BASE}/confirm-case`,
    method: 'get',
    params: params || {}
  })
}

export function getTrialFeatures () {
  return request({
    url: `${BASE}/trial-features`,
    method: 'get'
  })
}

export function addToBillingCart (data) {
  return request({
    url: `${BASE}/cart/add`,
    method: 'post',
    data: data || {}
  })
}

export function applyBillingPromoCoupons (data) {
  return request({
    url: `${BASE}/promo/apply`,
    method: 'post',
    data: data || {}
  })
}

export function getTrialReadiness (skuCode) {
  return request({
    url: `${BASE}/trial-readiness`,
    method: 'get',
    params: { skuCode: skuCode }
  })
}

export function updateTrialScope (data) {
  return request({
    url: `${BASE}/trial-scope`,
    method: 'put',
    data: data || {}
  })
}



// WEBPACK FOOTER //
// ./src/api/brandBilling.js